import { useEffect } from 'react'

interface Props {
  url: string
  posterUrl?: string
}

export default function ModelViewer({ url, posterUrl }: Props) {
  useEffect(() => {
    // Lazy-load the web component once on mount.
    if (!customElements.get('model-viewer')) {
      import('@google/model-viewer')
    }
  }, [])

  return (
    <div className="w-full h-full bg-[var(--color-bg)]">
      {/* @ts-expect-error model-viewer is a custom element */}
      <model-viewer
        src={url}
        poster={posterUrl}
        alt="3D scan"
        auto-rotate
        auto-rotate-delay="0"
        rotation-per-second="20deg"
        camera-controls
        touch-action="pan-y"
        exposure="1.1"
        shadow-intensity="0.6"
        tone-mapping="commerce"
        environment-image="neutral"
        interaction-prompt="when-focused"
        loading="eager"
        reveal="auto"
        style={{ width: '100%', height: '100%', backgroundColor: 'transparent' }}
      />
    </div>
  )
}
